import { ContainerComponent, wrap, today } from 'AppReact';
import Controller from './controller'
import { SecondaryTextXs, RedTextXs, ClickableIcon } from 'atoms';
import internalState from './internalState';
import {
  MakeReadyItemCellWrapper, Td, CustomBorderWrapper, FitRelativeWrapper, Px2,
  CustomHeight, MediaListScrollWrapper, Width270, BorderBottomWrapper, Mx4,
  Px3, Mb2, Mt5, MakeReadyDateInputCellWrapper, NotPaddedGrowWrapper, Mt4,
  FlexCenterJustifyEndWrapper, P2
} from 'wrappers';
import { format, isBefore } from 'date-fns';
import { TabButton } from 'molecules';
import { TrashBinSvg } from 'components/icons';
import CalendarMonth from '../calendarMonth';

export const definition = {
  name: 'DateInputCell',
  controller: Controller,
  initialProps: ({ data, displayConfetti, selectedRow, makeReadyCategory, showCheckboxes }) => ({
    displayConfetti,
    data,
    selectedRow,
    showCheckboxes,
    makeReadyCategory,
    selectedDate: data?.data ? new Date(data.data) : null,
    selectedYear: data?.data ? new Date(data.data)?.getFullYear() : today().getFullYear()
  }),
  props: internalState,
  elements: [
    {
      wrapper: FitRelativeWrapper,
      name: 'RelativeWrapper',
      renderIf: ({ selectedRow }) => !selectedRow,
      elements: [
        {
          wrapper: MakeReadyItemCellWrapper,
          name: 'Selector',
          renderIf: ({ displayConfetti }) => !displayConfetti,
          isButton: true,
          bindings: ({ isOpen, containerRef, yearListRef, monthListRef, selectedYear, selectedDate, showCheckboxes }) => ({ isOpen, containerRef, yearListRef, monthListRef, selectedYear, selectedDate, showCheckboxes }),
          displayState: ({ showCheckboxes }) => ({ background: showCheckboxes ? '#F7F7F7' : '' }),
          elements: [
            {
              component: wrap(SecondaryTextXs, Px2),
              renderIf: ({ selectedDate, makeReadyCategory }) => !!selectedDate && (isBefore(today(), selectedDate) || !makeReadyCategory.past_dates_in_red),
              name: 'Date',
              displayValue: ({ selectedDate }) => format(selectedDate, 'MM/dd/yy')
            },
            {
              component: wrap(RedTextXs, Px2),
              renderIf: ({ selectedDate, makeReadyCategory }) => makeReadyCategory.past_dates_in_red && !!selectedDate && isBefore(selectedDate, today()),
              name: 'PastDate',
              displayValue: ({ selectedDate }) => format(selectedDate, 'MM/dd/yy')
            },
          ]
        },
        {
          wrapper: MakeReadyDateInputCellWrapper,
          displayState: ({ isOpen, left, top }) => ({ isOpen, top: top ? `${top}px` : '0px', left: left ? `${left}px` : '0px' }),
          renderIf: ({ isOpen }) => isOpen,
          ref: ({ containerRef }) => containerRef ?? null,
          name: 'DropdownWrapper',
          elements: [
            {
              wrapper: CustomBorderWrapper,
              name: 'BorderWrapper',
              displayState: ({ }) => ({ borderRadius: '8px', border: '1px solid #E3E3E3', background: '#FFFFFF', width: '304px', height: '464px' }),
              elements: [
                {
                  wrapper: CustomHeight,
                  name: 'ListWrapper',
                  displayState: ({ }) => ({ height: 460, display: 'flex', flexDirection: 'column', width: '302px' }),
                  elements: [
                    {
                      wrapper: wrap(wrap(wrap(MediaListScrollWrapper, Width270), BorderBottomWrapper), Mx4),
                      name: 'YearList',
                      ref: ({ yearListRef }) => yearListRef,
                      elements: [
                        {
                          component: wrap(wrap(TabButton, Mb2), Mt4),
                          isListOf: { year: ({ }) => Array.from(Array(60).keys()) },
                          name: 'Year',
                          bindings: ({ year, monthListRef }) => ({ title: (year + 2000).toString(), year: year + 2000, monthListRef }),
                          displayState: ({ selectedYear, year }) => ({ fontWeightOnSelection: 600, primaryColor: true, fontSize: 12, selected: selectedYear === (year + 2000) })
                        },
                      ]
                    },
                    {
                      wrapper: NotPaddedGrowWrapper,
                      name: 'ListWrapper',
                      ref: ({ monthListRef }) => monthListRef,
                      elements: [
                        {
                          component: wrap(wrap(CalendarMonth, Mt5), Px3),
                          isListOf: { month: ({ }) => Array.from(Array(12).keys()) },
                          name: 'Month',
                          bindings: ({ month, selectedYear, selectedDate }) => {
                            return {
                              year: selectedYear,
                              month,
                              showToday: true,
                              selectedDates: [selectedDate],
                              dateMarginTop: '5px'
                            }
                          }
                        }
                      ]
                    },
                    {
                      component: wrap(wrap(ClickableIcon, FlexCenterJustifyEndWrapper), P2),
                      name: 'DeleteButton',
                      displayValue: ({ }) => TrashBinSvg({ width: '14', height: '16.5' }),
                      renderIf: ({ selectedDate }) => !!selectedDate,
                      bindings: ({ }) => ({}),
                    }
                  ]
                },
              ]
            }
          ]
        }
      ]
    }
  ]
}

export default wrap(ContainerComponent(definition), Td)